export const defaultConfig = {
  baseAPIUrl:
    process.env.NODE_ENV === "development"
      ? "http://local.orderart.com/api"
      : "https://posapi.orderart.com.au"
    //  :"http://192.168.29.114/api"
};

 export const ERROR_RECOVERY_CONFIG = {
  redirectOnError: false,
  redirectPath: '/dashboard',
  showToast: true,
  toastMessage: 'Something went wrong. Redirecting to dashboard...',
  preventLoop: true
};